<button
  class="follow"
  (click)="toggleButton($event)"
  [class.follow--activated]="activated"
>
  <div class="follow__image"></div>
</button>
